import React, { useEffect, useState } from 'react';
import { Form, Button, Layout, Typography } from 'antd';
import { Input } from '@webiz/admin-design-system';
import { Dispatch } from "redux";
import Logo from '../../assets/images/logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { is } from '../../services/helpers';
import { authenticate } from "../../store/auth";

const { Text } = Typography;

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch: Dispatch<any> = useDispatch();
  const isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated);
  const errorMessage = useSelector((state: any) => state.auth.errorMessage);
  const status = useSelector((state: any) => state.auth.status);
  const history = useHistory();

  useEffect(() => {
    if(isAuthenticated) {
      history.push('/users')
    }
  }, [isAuthenticated, history]);

  const onFinish = () => {
    dispatch(authenticate({email, password}));
  };

  return (
    <div className="login-container">
      <div className="login-logo">
        <img src={Logo} alt="Showit" />
      </div>
      <Layout className="login-layout">
        <Form
          onFinish={onFinish}
        >
          <Form.Item
            name="email"
            rules={[{ required: true, message: 'Email Is Requiard' }]}
          >
            <Input 
              label="email"
              className="login-input" 
              onChange={(e) => setEmail(e.target.value)} 
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Password Is Requiard' }]}
          >
            <Input 
              type="password" 
              label="password" 
              className="login-input"  
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Item>

          {errorMessage && <Text style={{ color: '#ff4d4f' }}>Wrong credentials</Text>}

          <Button 
            type="primary" 
            htmlType="submit" 
            className="login-btn"
            loading={is.request(status)}
          >
            Log in
          </Button>
        </Form>
      </Layout>
    </div>
  );
};

export default Login;
